export type AudienceTag =
  | 'USER'
  | 'PARENT'
  | 'PARTNER'
  | 'GG'
  | 'GP'
  | 'TEST';

export const AUDIENCE_TAGS: AudienceTag[] = [
  'USER',
  'PARENT',
  'PARTNER',
  'GG',
  'GP',
  'TEST',
];

/** Normalize free-form tag the same way as notification-service. */
export function normalizeAudienceTag(value: string): string | null {
  const normalized = value
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .toUpperCase();
  if (!normalized || normalized.length > 64) return null;
  return normalized;
}

export type AudienceFromDomain =
  | 'valvur.gg'
  | 'valvur.ai'
  | 'passport.gg'
  | 'passport.gp';

export const AUDIENCE_FROM_DOMAINS: AudienceFromDomain[] = [
  'valvur.gg',
  'valvur.ai',
  'passport.gg',
  'passport.gp',
];

export type PostmarkTemplateOption = {
  templateId: number;
  name: string;
  alias: string | null;
  active: boolean;
  templateType: string;
  layoutTemplate: string | null;
};

export type AudienceContact = {
  id: string;
  tags: string[];
  unsubscribedAt: string | null;
  createdAt: string;
};

export type AudienceContactsResponse = {
  items: AudienceContact[];
  total: number;
};

export type AudienceCampaign = {
  id: string;
  name: string | null;
  templateId: number;
  tags: string[];
  tagMatch: 'any' | 'all';
  fromDomain: AudienceFromDomain;
  fromAddress: string;
  messageStream: string;
  status: string;
  dryRun: boolean;
  batchSize: number;
  maxBatches: number;
  totalRecipients: number;
  remainingCount: number;
  sentCount: number;
  failedCount: number;
  skippedCount: number;
  startedAt: string | null;
  finishedAt: string | null;
  errorMessage: string | null;
  createdAt: string;
};

export type CreateAudienceCampaignRequest = {
  name?: string;
  tags: string[];
  match?: 'any' | 'all';
  templateId: number;
  fromDomain: AudienceFromDomain;
  variables?: Record<string, string | number | boolean>;
  dryRun?: boolean;
  batchSize?: number;
  maxBatches?: number;
};

export type UpdateAudienceCampaignSettingsRequest = {
  batchSize?: number;
  maxBatches?: number;
};

export type StartAudienceCampaignRequest = {
  batchSize?: number;
  maxBatches?: number;
  dryRun?: boolean;
};
